<template>
  <div class="employee-detail-layout">
    <div class="organization-page-title-container organization-page-title-row">
      <PageTitle class="organization-page-title-row__title" title="Organization" />
      <HelpMenu />
    </div>
    <OrganizationHorizontalMenu
      :menuItems="menuItems"
      initialTab="Employees"
      :count_of_active_employees="sidebarCountStore.employees"
      :count_of_active_positions="sidebarCountStore.positions"
      :count_of_active_roles="sidebarCountStore.roles"
      :count_of_active_responsibilities="sidebarCountStore.responsibilities"
      @tab-selected="handleTabChange"
    />
    <div class="layout-content">
      <router-view :key="$route.path" />
    </div>
  </div>
</template>

<script setup>
import { computed, getCurrentInstance } from "vue";
import { useRoute, useRouter } from "vue-router/composables";
import OrganizationHorizontalMenu from "@components/OrganizationHorizontalMenu/OrganizationHorizontalMenu.vue";
import PageTitle from "@components/common/PageTitle.vue";
import HelpMenu from "@components/HelpMenu/HelpMenu.vue";
import { useSidebarCountStore } from "@/store/pinia/sidebarCount";
import Home from "@components/assets/icons/Home.svg";
import Employee from "@components/assets/icons/Employee.svg";
import Position from "@components/assets/icons/Position.svg";
import Role from "@components/assets/icons/Role.svg";
import Responsibility from "@components/assets/icons/Responsibility.svg";

const instance = getCurrentInstance();
const router = instance?.proxy?.$router || useRouter();
const route = useRoute();
const sidebarCountStore = useSidebarCountStore();

const menuItems = computed(() => [
  { label: "Dashboard", icon: Home },
  { label: "Employees", icon: Employee },
  { label: "Positions", icon: Position },
  { label: "Roles", icon: Role },
  { label: "Responsibilities", icon: Responsibility },
]);

const handleTabChange = (tabLabel) => {
  const routes = {
    Dashboard: "/organization/dashboard",
    Employees: "/organization/employees",
    Positions: "/organization/positions",
    Roles: "/organization/roles",
    Responsibilities: "/organization/responsibilities",
  };

  const targetPath = routes[tabLabel];
  if (router && targetPath) {
    const resolved = router.resolve(targetPath);
    if (resolved.route.fullPath !== route.fullPath) {
      router.push(targetPath).catch(() => {});
    }
  }
};
</script>

<style scoped>
.employee-detail-layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px;
  margin-bottom: 12px;
}

.layout-content {
  flex: 1;
  width: 100%;
  margin-top: 12px;
}

.organization-page-title-container {
  padding: 24px 0px 0px 0px;
}

.organization-page-title-row {
  display: flex;
  align-items: center;
  gap: 7px;
}

.organization-page-title-row__title {
  flex: 1;
  min-width: 0;
}
</style>
